import serviceImg1 from '../images/service-1.svg'
import serviceImg2 from '../images/service-2.svg'
import customServiceImg1 from '../images/custom-website-service-1.jpg'
import customServiceImg2 from '../images/custom-website-service-2.jpg'
import wordpressServiceImg1 from '../images/wordpress-website-service-1.jpg'
import shopifyServiceImg1 from '../images/shopify-website-service-1.jpg'
import shopifyServiceImg2 from '../images/shopify-website-service-2.webp'
import ecommerceServiceImg1 from '../images/ecommerce-website-service-1.jpg'
import ecommerceServiceImg2 from '../images/ecommerce-website-service-2.jpg'
import mobileAppServiceImg1 from '../images/mobile-app-service-1.jpg'
import mobileAppServiceImg2 from '../images/mobile-app-service-2.png'
export const services = [
    {
        image: serviceImg1,
        imageShadeColor: 'rgba(0,138,252,.47)',
        title: 'Web Design & Development',
        paragraph: [
            `Every web design project at Visual Flick is unique and treated with the utmost care. Our team of award-winning web designers and web developers have a knack for creating visually stunning websites that are also functional and effective at achieving their goals. Whether you need a simple informational website or a complex e-commerce platform, we have the expertise to bring your brand's online presence to life. Let us help you create the perfect online presentation for your business.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    },
    {
        image: serviceImg2,
        title: 'Branding & Strategy',
        imageShadeColor: 'rgba(252,0,29,.3)',
        paragraph: [
            `Visual Flick can help your brand truly succeed in today's digital world by creating a strong brand identity and a creative visual design.`,
            `Our goal is to help your company achieve consistency, memorability, and credibility, and attract your target audience in the most effective way possible. We consider the psychology of branding in your target market while also considering a unique design perspective.  Our award-winning branding and design team has facilitated the success of our projects with their extensive industry knowledge and experience.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    }
]
export const additionalServices = [
    {
        title: 'SEO',
        paragraph: `Improving search engine results for companies to increase their internet presence.`,
        link: {
            title: 'Consult Now',
            href: '/'
        }
    },
    {
        title: 'Consultation',
        paragraph: `Guiding you through customized one-on-one sessions to identify the best solutions for your needs.`,
        link: {
            title: 'Consult Now',
            href: '/'
        }
    },
    {
        title: 'Graphic Design',
        paragraph: `Using graphic design and illustration to create marketing materials that work.`,
        link: {
            title: 'Consult Now',
            href: '/'
        }
    },
    {
        title: 'Content Marketing',
        paragraph: `Original material that broadens your audience's natural reach while adding value.`,
        link: {
            title: 'Consult Now',
            href: '/'
        }
    }
]

export const customWebsiteServices = [
    {
        image: customServiceImg1,
        imageShadeColor: 'rgba(116, 124, 129,0.4)',
        title: 'Productive Creation of Custom Websites',
        paragraph: [
            `As the domain owner, content management systems (also known as custom website development) provide you complete control over your website. With a strong Custom Website Development, you may download, upload, change, and alter data anyway you choose. The framework is flexible, so you may update the website with new features as needed. We builds Custom Website Development websites specifically to help business owners conveniently manage and maintain their website.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    },
    {
        image: customServiceImg2,
        title: 'Simplified customer service',
        imageShadeColor: 'rgba(116, 124, 129,0.3)',
        paragraph: [
            `Our web development company will help you establish a closer connection with your users by crafting the best possible webpage user experience.`,
            `You may target a certain demographic of potential customers and grow your client base with our innovative digital project-based technologies. `
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    }
]
export const wordpressWebsiteServices = [
    {
        image: wordpressServiceImg1,
        imageShadeColor: 'rgba(116, 124, 129,0.4)',
        title: `Explore WordPress's Potential with Visual Flick`,
        paragraph: [
            `Our abilities go beyond basic design and development; we are digital wizards capable of transforming your WordPress aspirations into amazing reality. Our magic formula blends technical wizardry, strategic sorcery, and artistic flair to create websites that captivate, persuade, and delight. Select us to unlock the full potential of your online presence.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    },
    {
        image: customServiceImg2,
        title: 'Better Customer Service with a Custom WordPress Plugin',
        imageShadeColor: 'rgba(116, 124, 129,0.3)',
        paragraph: [
            `We added administrative filters for improved client subscription administration, developed a customized plugin for subscription-data mapping, and customized the Member press WordPress plugin to allow multi-business registration.`,
            `Our expert developers can create websites of the highest caliber from scratch or collaborate with already-existing teams.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    }
]
export const shopifyWebsiteServices = [
    {
        image: shopifyServiceImg1,
        imageShadeColor: 'rgba(116, 124, 129,0.4)',
        title: `Ultimate Shopify Theme Development Company`,
        paragraph: [
            `Our leading Shopify development store employs some of the best Shopify theme developers to build a website that not only captivates your customers but also works flawlessly. The Shopify design services we provide include, but are not limited to: managing Shopify eCommerce store export processes, Shopify theme and app updates, round-the-clock Shopify eCommerce store security monitoring, updates and backup for your Shopify CMS, and tech maintenance and support for your Shopify store. We could assist you create a celestial, adaptable Shopify eCommerce store that maximizes conversion while communicating your brand values. `
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    },
    {
        image: shopifyServiceImg2,
        title: 'For a personalized shop, Shopify Theme Customization Services',
        imageShadeColor: 'rgba(116, 124, 129,0.3)',
        paragraph: [
            `An enthusiastic group of professionals at our Shopify eCommerce shop development firm will assist you in personalizing your Shopify store. With the help of us, you may adapt your website to your company needs and incorporate sophisticated features, unique capabilities, and unique workflows. Custom Shopify theme creation, custom Shopify app development, custom Shopify extensions, and custom Shopify integrations are just a few of the services we provide for Shopify customization.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    }
]
export const ecommerceWebsiteServices = [
    {
        image: ecommerceServiceImg1,
        imageShadeColor: 'rgba(116, 124, 129,0.4)',
        title: `Effective e-commerce Solutions`,
        paragraph: [
            `A first-rate service that enables companies all over the world to do business on a highly professional website and shopping cart solutions is e-commerce website design and development. Our skilled staff does all necessary to guarantee that your company gets the best services available to meet your demands as a business. To provide you an easy way to conduct business, we endeavor to coordinate and manage a storefront of a broad product range. The greatest firm for developing e-commerce websites across the globe.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    },
    {
        image: ecommerceServiceImg2,
        title: 'Our e-commerce system is integrated with search engine optimization',
        imageShadeColor: 'rgba(116, 124, 129,0.3)',
        paragraph: [
            `Our state-of-the-art e-commerce solutions are 100% XHTML compliant, setting them apart from other e-commerce web page creation and hosting alternatives. This indicates that there are no coding problems on your website preventing search engines from indexing it. Websites with no errors receive higher search engine rankings, more visibility, and more traffic that converts into purchases. The Ecommerce Solutions offered by Visual Flick go above and beyond in terms of search engine friendliness.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    }
]
export const mobileAppServices = [
    {
        image: mobileAppServiceImg1,
        imageShadeColor: 'rgba(116, 124, 129,0.4)',
        title: `Compelling Experiences:`,
        paragraph: [
            `Construct for the mobile-first web or change your company to align with the portable realities of present. Our team of experts uses the newest frameworks and technology to provide mobile app development solutions that will revolutionize your company.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    },
    {
        image: mobileAppServiceImg2,
        title: `Developing Every Mobile Feature That Today's Users Demand`,
        imageShadeColor: 'rgba(116, 124, 129,0.3)',
        paragraph: [
            `Whether developing a mobile app for a business or a consumer, we depend on our knowledge of various technologies and tools to create apps that are genuinely beneficial and worthy of your customers' screen real estate. Even though we can duplicate the functionalities, no two applications are the same since we give each one a distinct value proposition and customize the functionality to meet the demands of its target user base.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    }
]
export const logoDesignServices = [
    {
        image: mobileAppServiceImg1,
        imageShadeColor: 'rgba(116, 124, 129,0.4)',
        title: `Use expert design services to raise awareness of your business`,
        paragraph: [
            `After receiving the clients' comprehensive directions, the artists and the large workforce for logo design begin their job. Many fresh logo designs are created once the design is delivered promptly, taking into account all of the client's unique changes. As soon as the necessary changes are performed to the chosen logo styles, any necessary adjustments or transformations are provided. Additionally, there is a plan for quickly revising the design in order to establish ourselves as a reliable source for not just logo design but also establishing business relationships.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    },
    {
        image: mobileAppServiceImg2,
        title: `The brand's core values and principles will be conveyed in a variety of subtle ways through our logos.`,
        imageShadeColor: 'rgba(116, 124, 129,0.3)',
        paragraph: [
            `We think that each organization's success depends on having an amazing logo. In light of this, our design team has produced distinctive logos. The intricacy of the brand's foundational beliefs and ideas will be communicated through our logos. They will create miracles by crafting your brand's story and striking a balance between beauty and usefulness.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    }
]
export const socialMediaServices = [
    {
        image: mobileAppServiceImg1,
        imageShadeColor: 'rgba(116, 124, 129,0.4)',
        title: `Use expert design services to raise awareness of your business`,
        paragraph: [
            `After receiving detailed client instructions, our social media team creates tailored content and visuals. We promptly develop multiple fresh designs, incorporating all client-specific changes and making necessary adjustments quickly. Our commitment to fast revisions and personalized service helps us build lasting business relationships, not just for social media marketing but for ongoing collaboration.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    },
    {
        image: mobileAppServiceImg2,
        title: `Our social media content subtly conveys your brand’s core values and principles through thoughtfully designed visuals and messaging.`,
        imageShadeColor: 'rgba(116, 124, 129,0.3)',
        paragraph: [
            `We believe that exceptional social media content is key to your organization’s success. Our team crafts unique visuals and messaging that convey your brand’s core values and story, balancing creativity with effectiveness.`
        ],
        link: {
            title: 'Website Services',
            href: '/'
        }
    }
]